import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomFieldDefinition } from 'types/customField';
import request from 'utils/request';
import { EVENTS_CUSTOM_FIELDS_KEY } from './useEventCustomFieldDefinitions';

function updateEventCustomField({
  schoolyearId,
  schoolId,
  data,
}: {
  schoolyearId: string;
  schoolId: string;
} & {
  data: CustomFieldDefinition;
}) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/events-custom-fields/${data.id}`,
    {
      method: 'PATCH',
      body: data,
    },
  );
}

export const useUpdateEventCustomFieldDefinition = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CustomFieldDefinition) =>
      updateEventCustomField({ schoolyearId, schoolId, data }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EVENTS_CUSTOM_FIELDS_KEY, schoolyearId, schoolId],
      });
    },
  });
};
